import { FEATURES, PRODUCTS } from '@/base/constants/authorization'

// CSV Export Rules
export const asoCsvExportComponentRule = {
  $and: [
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.EXPORT_CSV },
        },
      },
    },
  ],
}

export const marketCsvExportComponentRule = {
  $and: [
    { name: { $eq: PRODUCTS.MARKET_ENTERPRISE } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.EXPORT_CSV },
        },
      },
    },
  ],
}

// Custom Alert Rule
export const asoCustomAlertComponentRule = {
  $and: [
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.EXPORT_CSV },
        },
      },
    },
  ],
}

// Date Comparison Rule
export const asoCompareDatesComponentRule = {
  $and: [
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.COMPARE_DATES },
        },
      },
    },
  ],
}

// Organic Visibility Rule
export const asoOrganicVisibilityComponentRule = {
  $and: [
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_ORGANIC_VISIBILITY_HISTORY },
        },
      },
    },
  ],
}

// App Update Pins Rule
export const asoAppUpdatePinsComponentRule = {
  $and: [
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_APP_UPDATE_PINS },
        },
      },
    },
  ],
}

// Chart Annotation Rule
export const asoChartAnnotationComponentRule = {
  $and: [
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ADD_CHART_ANNOTATION },
        },
      },
    },
  ],
}

// Historical Data Rules
export function getMarketHistoricalDataRule(totalSelectedDays) {
  return {
    $and: [
      {
        $or: [
          { name: { $eq: PRODUCTS.MARKET_ENTERPRISE } },
          { name: { $eq: PRODUCTS.MARKET_PRO } },
        ],
      },
      {
        featureSet: {
          $elemMatch: {
            $and: [
              { type: { $eq: FEATURES.ACCESS_HISTORICAL_DATA } },
              { quota: { $gte: totalSelectedDays } },
            ],
          },
        },
      },
    ],
  }
}

export function getASOHistoricalDataRule(totalSelectedDays) {
  return {
    $and: [
      {
        $or: [
          { name: { $eq: PRODUCTS.ASO_LITE } },
          { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
          { name: { $eq: PRODUCTS.ASO_PRO } },
          { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        ],
      },
      {
        featureSet: {
          $elemMatch: {
            $and: [
              { type: { $eq: FEATURES.ACCESS_HISTORICAL_DATA } },
              { quota: { $gte: totalSelectedDays } },
            ],
          },
        },
      },
    ],
  }
}

export const accessChartAnnotationRule = {
  name: { $eq: PRODUCTS.ASO_BUSINESS },
}

export const accessAddChartAnnotationRule = {
  $and: [
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ADD_CHART_ANNOTATION },
        },
      },
    },
  ],
}

export const accessExploreCustomDateSelectRule = {
  $and: [
    { name: { $eq: PRODUCTS.COMPASS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.EXPLORE_CUSTOM_DATE },
        },
      },
    },
  ],
}
